import PropTypes from 'prop-types';
import { path } from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Chat from '@material-ui/icons/Chat';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';

import grey from '@material-ui/core/es/colors/grey';

import { inboxClose, inboxOpen } from '../modules/actions/layout';

const AdapterLink = React.forwardRef((props, ref) => <Link innerRef={ref} {...props} />);


class Header extends Component {
  static propTypes = {
    title: PropTypes.node.isRequired,
  };

  toggleInbox = () => {
    const { open, inboxOpen, inboxClose } = this.props;

    if (open) inboxClose();
    else inboxOpen();
  };

  render() {
    const { classes, title } = this.props;

    return (
      <AppBar position="absolute" className={[classes.appBar, 'no-user-select'].join(' ')}>
        <Toolbar>
          {title && (
            <Typography variant="h6" className={classes.title}>
              {title}
            </Typography>
          )}

          <Button color="inherit" component={AdapterLink} to="/">Dashboard</Button>
          <Button color="inherit" component={AdapterLink} to="/help">Help</Button>

          <div onClick={() => this.toggleInbox()}>
            <IconButton component="span"><Chat /></IconButton>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapStateToProps = (state) => ({
  open: path(['layout', 'inboxOpen'], state) || false,
});

const mapDispatchToProps = {
  inboxOpen,
  inboxClose,
};

const styles = {
  appBar: {
    backgroundColor: grey[100],
    color: grey[800],
    zIndex: 1250,
  },
  title: {
    flexGrow: 1,
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Header));
